import React, { PureComponent } from 'react';
import Select from './EditSelect.js';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faEraser } from '@fortawesome/free-solid-svg-icons'

import Loadable from '../ui/loading/Loadable.js';
import Box from '../ui/Box.js';

import './SelectInterface.scss';

class SelectInterface extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			addFormIsOpen: false,
			editFormIsOpen: false,
			editValue: null
		};

		this.onEditClick = this.onEditClick.bind(this);
		this.onEditSubmit = this.onEditSubmit.bind(this);
		this.onAddSubmit = this.onAddSubmit.bind(this);

		this.closeEditForm = this.closeEditForm.bind(this);
		this.closeAddForm = this.closeAddForm.bind(this);
		this.openAddForm = this.openAddForm.bind(this);
		this.openEditForm = this.openEditForm.bind(this);
		this.clearSelection = this.clearSelection.bind(this);
	}
	
	
	closeAddForm() { this.setState({addFormIsOpen: false}); }
	closeEditForm() { this.setState({editFormIsOpen: false}); }
	openAddForm(e) { 
		if (e) {
			e.stopPropagation();
			e.preventDefault();
		}
		this.setState({addFormIsOpen: true}); 
	}
	openEditForm() { this.setState({editFormIsOpen: true}); }
	
	onEditClick(e, p) {
		this.setState({editValue: p});
		this.openEditForm();
	}
	
	async onEditSubmit(e) {
		if (this.props.onEditSubmit) {
			let r = await this.props.onEditSubmit(this.state.editValue, e);
			if (r) {
				this.closeEditForm();
			}
		}
	}

	async onAddSubmit(e) {
		if (this.props.onAddSubmit) {
			let r = await this.props.onAddSubmit(this.state.editValue, e);
			if (r)
				this.closeAddForm();
		}
	}

	clearSelection() {
		if (this.props.onChange) {
			this.props.onChange({'value': null});
		}
	}

	render() {
		let editForm = this.props.editForm !== false && React.createElement(this.props.editForm, {
			data: this.state.editValue,
			onSubmit: this.onEditSubmit
		});

		let addForm = this.props.editForm !== false && React.createElement(this.props.addForm, {
			...this.props.addParams,
			data: {value: null, label: ''},
			onSubmit: this.onAddSubmit
		});


		// Overload the label with the correct one if it's changed
		let v = this.props.value;
		if (v.hasOwnProperty('value')) {
			for(let i=0; i < this.props.options.length; i++) {
				// It's either grouped or its not
				if (this.props.options[i].hasOwnProperty('options')) { 
					for (let t=0; t < this.props.options[i].options.length; t++) {
						if (v.value === this.props.options[i].options[t].value)
							v['label'] = this.props.options[i].options[t].label;
					}
				} else {
					if (v.value === this.props.options[i].value)
						v['label'] = this.props.options[i].label;
				}
			}
		}


		return (
			<div className={(this.props.className || '' ) + " select-interface"}>
				<Loadable ready={this.props.options !== false}>
					<Select
						placeholder={this.props.placeholder}
						value={v}
						options={this.props.options}
						onChange={this.props.onChange}
						onEditClick={this.props.editForm !== false && this.onEditClick}
						filterOption={this.props.filterOption}
					/>
				</Loadable>
				{this.props.showClear === true && 
					<button className="block plus" type="button" title={"Clear the selection"} onClick={this.clearSelection}>
						<FontAwesomeIcon icon={faEraser}/>
					</button>
				}
				{this.props.addForm !== false &&
					<>
						<button className="block plus" type="button" title={"Add a " + this.props.type} onClick={this.openAddForm}>
							<FontAwesomeIcon icon={faPlus}/>
						</button>
						<Box
							modal={true}
							isOpen={this.state.addFormIsOpen}
							onRequestClose={this.closeAddForm}
							title={"Add a new " + this.props.type}
						>
							{addForm}
						</Box>
					</>
				}
				{this.props.editForm !== false &&
					<Box
						modal={true}
						isOpen={this.state.editFormIsOpen}
						onRequestClose={this.closeEditForm}
						title={"Edit " + this.props.type + ": " + (this.state.editValue ? (this.state.editValue.label || '') : '')}
					>
					{editForm}
					</Box>
				}
			</div>
		);
	}
}

export default SelectInterface;
